import { useState, useEffect } from 'react'

export default useAcl = (user = Weaver.getInstance().currentUser()) ->

  [userRoles, setUserRoles] = useState(undefined)
  [userProjects, setUserProjects] = useState(undefined)

  # disabled the check for roles of roles because Weaver.Role.list() isn't
  # accessible for regular users
  getUserRoles = (projects, user = Weaver.getInstance().currentUser()) ->
    # userRoles = await user.getRoles()
    # allRoles = []
    # getRoleRoles = (roles) ->
    #   roles.forEach((role)->
    #     if role.roleId not in allRoles
    #       allRoles.push(role)
    #       roleRoles = await role.getRoles()
    #       if roleRoles.length
    #         getRoleRoles(roleRoles)
    #   )
    # await getRoleRoles(userRoles)
    # setUserRoles(allRoles)
    # allRoles
    await user.getRoles()

  getUserProjects = (user = Weaver.getInstance().currentUser()) ->
    projectList = await Weaver.Project.list()
    userRoles = await getUserRoles(user)
    projects = await Promise.all(projectList.map((project)->
      acl = await project.getACL()
      project.readAccess = (userRoles)
        .map((role)-> acl.getRoleReadAccess(role))
        .concat(acl.getUserReadAccess(user))
        .some((canRead)-> canRead)
      project.writeAccess = (userRoles)
        .map((role)-> acl.getRoleWriteAccess(role))
        .concat(acl.getUserWriteAccess(user))
        .some((canRead)-> canRead)
      project
    ))

    userProjects = _.chain(projects)
      .sortBy(['name'])
      .value()

    setUserProjects(userProjects)
    userProjects

  useEffect(->
    (->
      projects = await getUserProjects()
      await getUserRoles(projects)
    )()
    undefined
  , [])

  { userRoles, userProjects, getUserRoles, getUserProjects }
